import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    chatRoomId: null,
    groupCreationUsersList: [],
    groupName: null,
    chatCloseFunction: null,
    rowDetails: null,
    refreashNeeded: false,
};


const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    openChat: (state, action) => {
      return {
        ...state,
        open: true,
        ...action.payload,
      };
    },
    closeChat: (state) => ({ ...initialState, refreashNeeded: state.refreashNeeded }),
    setRefreashNeeded: (state, action) => {
      state.refreashNeeded = action.payload;
    }
  },
});
export const { openChat, closeChat, setRefreashNeeded } = chatSlice.actions;

export default chatSlice.reducer;
